<template lang="pug">
.onboarding-step
  .onboarding-step-header
    h1 Create Your First Board
    p Alright, lets create a place to come up with new ideas. A board is a place where people can post and vote on ideas for a specific topic.
    br
    p Some examples might include "Product Enhancements", "Bugs", or "Integrations"
  .onboarding-step-content
    .row.center
      .col.max
        form(@submit.prevent="submit")
          div.form-field(:class="{error: $v.form.name.$error, 'error-required': !$v.form.name.required}")
            label
              input(v-model="$v.form.name.$model", type="text", placeholder="Board Name")
          div.form-field
            label
              textarea(v-model="form.description", placeholder="Board Description")
          div.form-field.no-margin
            SubmitButton(label="Create", :formState="formState")
      .col.max.animation
        LottieAnimation(svg="onboarding_2", :width="200", :height="200")
</template>

<script>
  import LottieAnimation from '@/components/helpers/LottieAnimation'
  import { required } from 'vuelidate/lib/validators'
  import { form } from '@/mixins/form'

  export default {
    name: 'OnboardingBoardCreate',
    mixins: [form],
    components: {
      LottieAnimation
    },
    beforeMount () {
    },
    data () {
      return {
        formState: 'initial',
        error: null,
        form: {
          name: '',
          description: ''
        }
      }
    },
    validations: {
      form: {
        name: {
          required
        }
      }
    },
    computed: {
    },
    methods: {
      submit () {
        if (this.__formInvalid()) return
        this.formState = 'pending'
        this.$store.dispatch('boards/postBoard', this.form)
          .then((board) => {
            console.log(`result = `, board)
            this.$store.commit('boards/SELECT_BOARD', board.slug)
            // go to next step
            this.$emit('next')
          }, errors => {
            this.formState = 'initial'
            this.error = errors
            console.log(errors)
          })
      }
    }
  }
</script>

<style lang="stylus" scoped>
.onboarding-step
  border $border-default
  .onboarding-step-header
    background-color $background-color
    border-bottom $border-default
    padding $spacing-3
    h1
      font-size 22px
      margin-bottom 30px
    p
      color $text-light
  .onboarding-step-content
    padding $spacing-3
  .animation
    +for_breakpoint(mobile)
      display none
</style>
